module.exports = __webpack_public_path__ + "img/about-values-trust.jpg?f78aef7497786e48189c8546b59469ba";